class AncillaryPage extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.hasBeenClicked = false
    this.setup()
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(this, 'click', this.handleClick.bind(this))
    this.listeners.add(this, 'AFTER_ACCORDION_ANIMATION', event => {
      if (
        !this.hasBeenClicked ||
        !event?.detail?.element ||
        !event?.detail?.open ||
        this.hasSearchTerm
      ) {
        return
      }
      const rect = event.detail.element.getBoundingClientRect()
      const announcementBar = document.querySelector('header-announcement-bar')
      const announcementBarHeight =
        announcementBar !== null ? announcementBar.offsetHeight : 0
      const headerEl = document.querySelector('.hd-Header')
      const headerHeight = headerEl?.offsetHeight || 0
      const combinedHeight = announcementBarHeight + headerHeight

      window.BAO.Utils.scrollToY(rect.top + window.scrollY - combinedHeight)
    })

    if (this.hasSearch) {
      this.debouncedHandleSearch = window.BAO.Utils.debounce(event => {
        this.searchTerm = event.target.value
        this.handleAnalytics()
      }, 250)
      this.listeners.add(
        this.searchEl,
        'keyup',
        this.debouncedHandleSearch.bind(this),
      )
    }
  }

  handleAnalytics () {
    history.pushState(null, null, `#faqSearchTerm=${this.searchTerm}`)

    if (this.searchTerm.length > 3) {
      window.dataLayer.push({
        event: 'faqSearchTerm',
        searchTermPath: window.location.href,
        searchTermValue: this.searchTerm,
      })
    }
  }

  setup () {
    this.isSetup = false
    if (this.hasSearch) {
      // eslint-disable-next-line compat/compat
      const searchParams = new URLSearchParams(window.location.search)
      this.searchTerm = searchParams.get('search')
    }

    const hasHash = Boolean(window.location.hash)
    const isAboveMobile = window.innerWidth > 767
    const shouldHaveActiveKey = hasHash || isAboveMobile

    if (this.hashEls && shouldHaveActiveKey) {
      this.currentKey = this.hash
    }
    this.isSetup = true
  }

  handleClick (event) {
    const target = event.target.closest(this.els?.hash?.selector)
    const isHashChild = event.target.closest(this.els?.hashChild?.selector)
    if (!target || isHashChild) return
    this.hasBeenClicked = true
    this.currentKey = target.dataset.key
    if (this.hasSearchTerm) {
      this.searchTerm = ''
    }
  }

  toggleAccordion (accordionEl, boolean, shouldScroll) {
    accordionEl.setAttribute(`data-expand-by-default`, boolean)
    if (boolean) {
      accordionEl.open()
    } else {
      accordionEl.shrink()
    }
  }

  set currentKey (key) {
    if (!this.isSetup && this.hasSearchTerm) return
    const currentKey = this.availableKeys.includes(key)
      ? key
      : this.availableKeys?.[0]
    this._currentKey = currentKey

    if (history.pushState) {
      history.pushState(null, null, `#${currentKey}`)
    }

    this.hashEls.forEach(hashEl => {
      const isCurrent = hashEl.dataset?.key === currentKey
      const alreadyCurrent = hashEl.getAttribute(`aria-current`) === `true`

      if (window.innerWidth > 767 && isCurrent && alreadyCurrent) return

      hashEl.setAttribute(`aria-hidden`, `false`)
      hashEl.setAttribute(`aria-current`, isCurrent && !alreadyCurrent)

      if (hashEl.localName === `accordion-element`) {
        this.toggleAccordion(hashEl, isCurrent && !alreadyCurrent)
        const childAccordionEls = window.BAO.Utils.getElements(
          `accordion-element`,
          {
            context: hashEl,
          },
        )
        childAccordionEls.forEach(childAccordionEl =>
          childAccordionEl.setAttribute(`aria-hidden`, `false`),
        )
      }
    })
    this.hideNoResultsEl(true)
  }

  get currentKey () {
    return this._currentKey
  }

  get availableKeys () {
    return this.hashEls.map(hashEl => hashEl.dataset?.key)
  }

  get hash () {
    const hash = window.location.hash
    return hash ? hash.replace(`#`, ``) : this.hashEls?.[0]?.dataset?.key
  }

  get hashEls () {
    return this.els?.hash?.elements
  }

  get searchEl () {
    return this.els?.search?.element
  }

  get hasSearch () {
    return !!this.searchEl
  }

  get minimumCharacters () {
    const minimumCharacters = this.searchEl?.dataset?.minimumCharacters
    return minimumCharacters ? parseInt(minimumCharacters, 10) : 1
  }

  get noResultsEl () {
    return this.els?.noResults?.element
  }

  get noResultsTranslation () {
    return this.noResultsEl?.dataset?.translationNoResults || ``
  }

  get accordionEls () {
    return (
      window.BAO.Utils.getElements(`accordion-element`, { context: this }) || []
    )
  }

  get hasSearchTerm () {
    return this.searchTerm && this.searchTerm.length > this.minimumCharacters
  }

  get searchTerm () {
    return this._searchTerm
  }

  set searchTerm (searchTerm) {
    this._searchTerm = searchTerm

    if (this.searchEl) {
      this.searchEl.value = searchTerm
      this.handleSearch(searchTerm)
    }
  }

  handleSearch (searchTerm) {
    if (!this.hasSearchTerm) {
      this.showAllHashEls()
      return
    }

    let shouldScroll = true

    const elementsToShow = this.accordionEls.filter(accordionEl => {
      const resultFound = accordionEl.textContent
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
      this.toggleAccordion(accordionEl, resultFound, shouldScroll)
      shouldScroll = false

      return resultFound
    })

    if (window.dataLayer) {
      window.dataLayer.push({
        page_type: 'faq',
        event: 'faq_search',
        search_term: `${searchTerm}`,
      })
    }

    const visibleKeys = elementsToShow.map(
      elementToShow => elementToShow.dataset?.key,
    )
    this.hashEls.forEach(hashEl => {
      const elementToHide =
        hashEl.localName === `a` ? hashEl.parentNode : hashEl
      elementToHide.setAttribute(
        `aria-hidden`,
        !visibleKeys.includes(hashEl.dataset?.key),
      )
    })

    if (elementsToShow.length === 0) {
      this.noResultsEl.textContent = this.noResultsTranslation.replace(
        `[terms]`,
        searchTerm,
      )
      this.noResultsEl.style = ``
    }
    this.hideNoResultsEl(!!elementsToShow.length)

    if (!elementsToShow[1]) return

    setTimeout(() => {
      const rect = elementsToShow[1]
        ?.querySelector('summary')
        ?.getBoundingClientRect()
      const announcementBar = document.querySelector('header-announcement-bar')
      const announcementBarHeight = announcementBar?.offsetHeight || 0
      const headerEl = document.querySelector('.hd-Header')
      const headerHeight = headerEl?.offsetHeight || 0
      const combinedHeight = announcementBarHeight + headerHeight

      if (rect) {
        window.BAO.Utils.scrollToY(rect.top + window.scrollY - combinedHeight)
      }
    }, 500)
  }

  hideNoResultsEl (boolean) {
    if (!this.noResultsEl) return
    this.noResultsEl.setAttribute(`aria-hidden`, boolean)
  }

  showAllHashEls () {
    this.hashEls.forEach(hashEl => {
      const elementToShow =
        hashEl.localName === `a` ? hashEl.parentNode : hashEl
      elementToShow.setAttribute(`aria-hidden`, `false`)
    })
  }
}

if (!customElements.get('ancillary-page')) {
  customElements.define('ancillary-page', AncillaryPage)
}
